<template>
  <div>
    <closing-date-view />
  </div>
</template>

<script>
import ClosingDateView from '@/modules/tenders/view/ClosingDate'

export default {
  components: { ClosingDateView },
}
</script>

<style>

</style>
